export const PARTICIPATIONS_DISTINCT_RANSACK_KEYS = [
  'participation_prizes_name_in',
  'scenarios_id_in',
  'scenario_executions_data_contains_json',
];

export function resolveParticipationsDistinct(q = {}, {withMedia = false} = {}) {
  // with_media joins participations to their visuals, which can return multiple rows per participation
  if (withMedia) {
    return true;
  }

  const {g, ...rest} = q;
  const keys = [...Object.keys(rest), ...Object.keys(g || {})];
  return keys.some((key) => PARTICIPATIONS_DISTINCT_RANSACK_KEYS.includes(key));
}

export function mapLevelOptions(data = []) {
  const numbers = data.map((item) => item.number);
  const uniqueNumbers = [...new Set(numbers)];
  return uniqueNumbers.sort();
}

export const mapTimelineStatistic = (data) => {
  return {
    points: data.map(({time}) => time),
    visits: data.map(({visits_count}) => visits_count),
    participations: data.map(({participations_count}) => participations_count),
  };
};
